import { Cascader } from 'antd';
import classNames from 'classnames';
import { EmptySearchColor } from 'patternx-svg';
import React, { useImperativeHandle, useState } from 'react';
import styles from './index.module.less';
interface IStateSearchTag {
  labels: any[];
  onChange: Function;
}

export default React.forwardRef((props: IStateSearchTag, ref: any) => {
  const [selectedValue, setSelectedValue] = useState<string[]>([]);
  const onChange = (ids: any) => {
    let tagCode = '';
    if (ids && ids.length > 0) {
      tagCode = ids.slice(-1)[0];
    }
    setSelectedValue(ids);
    props.onChange(tagCode, ids);
  };

  const _setSelectValue = (ids: string[]) => {
    setSelectedValue(ids);
  };

  const clear = () => {
    setSelectedValue([]);
    props.onChange('');
  };

  useImperativeHandle(ref, () => ({
    clear,
    _setSelectValue,
  }));

  return (
    <>
      <label className="text-grey-5 ml8">分类：</label>
      <Cascader
        value={selectedValue}
        showSearch={true}
        placeholder="全部"
        changeOnSelect={true}
        expandTrigger="hover"
        style={{ maxWidth: 120 }}
        bordered={false}
        options={props.labels}
        onChange={onChange}
        fieldNames={{
          label: 'name',
          value: 'id',
          children: 'children',
        }}
        notFoundContent={
          <div className={classNames(styles.cascaderElement)}>
            <EmptySearchColor size={120} />
            <span>没有找到相关结果</span>
          </div>
        }
      />
    </>
  );
});
